import application from 'application/application';

import template from './terms-conditions.template.html';

import controller from './terms-conditions.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider
			.state('root.termsConditions', {
				url: '/termos-e-condicoes',
				views: {
					root: {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Termos e Condições de Uso do Advise'
				},
				params: {
					authentication: false
				}
			})
			.state('root.termsConditionsf', {
				url: '/termos-e-condicoes/:version',
				views: {
					root: {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Termos e Condições de Uso do Advise'
				},
				params: {
					authentication: false
				}
			});
	}
]);
